``
<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <upload-image-direct
              @loading="btnIsLoading = $event"
              @inputChanged="uplodeImg_1"
              :data_src="data.preview"
              title="صورة القائمة"
              model="menus"
            ></upload-image-direct>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  class="form-control"
                  rows="5"
                  v-model="data.en.desc"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> قسم المتجر </label>
                <multiselect
                  v-model="data.category"
                  :options="categories"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>

            <!-- <div class="col-12 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.priority") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  rows="5"
                  v-model="data.priority"
                />
              </div>
            </div> -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.categories.title"),
          disabled: false,
          href: "/menus/show-all",
        },
        {
          text: this.$t("breadcrumb.categories.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        category: null,
        is_active: false,
        preview: null,
      },

      // Fixed Data
      categories: [],
    };
  },

  methods: {
    getCategories() {
      this.$axios.get("store_category_not_paginated").then((res) => {
        // console.log(res.data)
        this.categories = res.data.data.map((el) => {
          return { id: el.id, name: `${el.name}` };
        });
      });
    },
    uplodeImg_1(obj) {
      console.log(obj);
      this.data.image = obj;
    },
    getData() {
      this.$axios.get(`menus/${this.id}`).then((res) => {
        const result = res.data.data;
        this.data.ar.name = result.ar.name;
        this.data.en.name = result.en.name;
        this.data.ar.desc = result.ar.desc;
        this.data.en.desc = result.en.desc;
        this.data.is_active = result.is_active;
        this.data.category = {
          id: result.place_category.id,
          name: `${result.place_category.name}`,
        };
        this.data.preview = result.image;
      });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.desc_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.desc_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.category) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار قسم المتجر",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;

      const submit_data = new FormData();
      if (this.data.image) {
        submit_data.append("image", this.data.image);
      }
      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("ar[desc]", this.data.ar.desc);
      submit_data.append("en[name]", this.data.en.name);
      submit_data.append("en[desc]", this.data.en.desc);
      submit_data.append("place_category_id", this.data.category.id);
      submit_data.append("is_active", this.data.is_active ? 1 : 0);
      submit_data.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `menus/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });

          this.$router.push({ path: "/menus/show-all" });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
  created() {
    this.getCategories();
    this.getData();
  },
};
</script>
